module.exports = __webpack_public_path__ + "static/img/qualifications_row_21.5811402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_21.png
// module id = h/ld
// module chunks = 1